import styled from 'styled-components';
import { Box } from '@mui/material';

export const Container = styled(Box)`
  display: flex;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  padding: ${({ theme }) => theme.spacing(4, 0)};
  background-color: ${({ theme }) => theme.palette.grey[100]};
`;
